import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

import { LinkTo } from "../types";
import { SplitBanner } from "../components/split-banner";
import { SplitBannerProps } from "../components/split-banner/SplitBanner";

interface ContentfulSplitBannerProps {
  __typename: string;
  image: VinoDataImage;
  imagePosition: "left" | "right";
  textAlign: "left" | "center" | "right";
  backgroundColor: string;
  headerImage: VinoDataImage;
  title?: string;
  subtitle?: string;
  bodyText?: string;
  titleColor?: string;
  subtitleColor?: string;
  bodyTextColor?: string;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label: string;
    linkTo: LinkTo;
  };
}

const test = ({ __typename }: ContentfulSplitBannerProps): boolean =>
  __typename === "VinoData_SplitBanner";

const create = (data: ContentfulSplitBannerProps): JSX.Element => {
  const transformedData: SplitBannerProps = {
    ...data,
    image: generateStorefrontImage(data.image, {}),
    headerImage: generateStorefrontImage(data.headerImage, {}),
  };

  return <SplitBanner {...transformedData} />;
};

export default { test, create };
